import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as listsActions from '../store/lists/actions';
import * as adsActions from '../store/ads/actions';
import * as reducers from '../store/reducers';
import { capitalize } from '../settings';
import { Bling as GPT } from 'react-gpt';

import ContentCollections from 'Containers/ContentCollections';
import Hero from 'Containers/Hero';
import RampUnit from '../utils/Playwire/RampUnit';
import Loading from 'Components/Loading';
import DocumentHeadFields from 'Components/DocumentHeadFields';
import VideoSiderailPlayer from 'Components/VideoSiderailPlayer';
import ErrorPage from 'Screens/ErrorPage';

import { withLocationWrapper } from '../utils/HOC_LocationWrapper';

class MediaLandingPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageLoading: true,
    };

    this.onAdLoad = this.onAdLoad.bind(this);
    this.onAdClick = this.onAdClick.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  onAdLoad() {
    const {
      trackAdInternal,
      trackAdThirdParty,
      heroAdCampaign,
      mediaType,
    } = this.props;
    if (heroAdCampaign)
      trackAdInternal(`${mediaType}LandingHero`, 'AD_VIEWED', heroAdCampaign);
    if (heroAdCampaign && heroAdCampaign.impressionTrackingURI) {
      trackAdThirdParty(
        `${mediaType}LandingHero`,
        'AD_VIEWED',
        heroAdCampaign.impressionTrackingURI
      );
    }
  }

  onAdClick(eventId, elementId) {
    const {
      trackAdInternal,
      trackAdThirdParty,
      heroAdCampaign,
      mediaType,
    } = this.props;
    if (heroAdCampaign)
      trackAdInternal(
        `${mediaType}LandingHero`,
        eventId,
        heroAdCampaign,
        elementId
      );
    if (heroAdCampaign && heroAdCampaign.clickTrackingURI) {
      trackAdThirdParty(
        `${mediaType}LandingHero`,
        'AD_CLICKED',
        heroAdCampaign.clickTrackingURI
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.fetchData();
      this.setState({ pageLoading: true });
    }
    if (!this.props.isFetching && this.state.pageLoading) {
      this.setState({ pageLoading: false });
    }
  }

  fetchData() {
    const { fetchMediaLists, mediaType, location } = this.props;
    const qs = {};

    fetchMediaLists(`${mediaType}Landing`, location.pathname, qs);
  }

  render() {
    const {
      isFetching,
      errors,
      lists,
      hero,
      mediaType,
      heroAdCampaign,
    } = this.props;
    const { pageLoading } = this.state;
    const hasSponsoredHero = typeof heroAdCampaign !== 'undefined';
    const displayedHero = hasSponsoredHero ? heroAdCampaign : hero;
    if (errors.lists && !lists) {
      return (
        <ErrorPage
          errorCode="500"
          errorType="unknownError"
          errorMessage={errors.lists.message}
        />
      );
    }
    if (pageLoading) {
      return <Loading />;
    }
    const loadAds = !pageLoading;
    return (
      <main>
        <DocumentHeadFields
          documentTitle={`Online ${capitalize(mediaType)} for Kids`}
        />
        <div className="Page__container Page__container--no-padding">
          <RampUnit type="leaderboard_atf" id="top" />
        </div>
        <div className="Page__ContentWrapper">
          <div className="Page__container Page__container--split-layout Page__container--main">
            {displayedHero && (
              <Hero
                hero={displayedHero}
                sponsored={hasSponsoredHero}
                heroType="media"
                onAdLoad={this.onAdLoad}
                onAdClick={elementId => this.onAdClick('AD_CLICKED', elementId)}
              />
            )}
            <aside className="ContentBlock__aside hide-for-mobile">
              <VideoSiderailPlayer />
              <RampUnit type="med_rect_atf" id="siderec" />
              <RampUnit type="med_rect_btf" id="sideflex" />
            </aside>
            <section className="ContentBlock">
              <div className="ContentBlock__content">
                {!isFetching && <ContentCollections lists={lists} />}
              </div>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, { routeProps, location }) => {
  const mediaType = routeProps.name;
  return {
    mediaType,
    isFetching: reducers.getIsPageFetching(state),
    hero: reducers.getHero(state, location.pathname),
    heroAdCampaign: reducers.getAdCampaign(state, `${mediaType}LandingHero`),
    lists: reducers.getMediaLists(
      state,
      `${mediaType}Landing`,
      location.pathname
    ),
    errors: reducers.getErrors(state),
  };
};

const MediaLandingPageComponent = connect(mapStateToProps, { ...listsActions, ...adsActions })(MediaLandingPage);

export default withLocationWrapper(MediaLandingPageComponent);
